module.exports = __webpack_public_path__ + "static/img/07.ff5d43af.png";